import { Spacings, View } from "react-native-ui-lib";
import { useCartContextProvider } from "../../hooks";
import { Text, IconButton, Divider } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "@towersystems/roam-common/lib/shared-utils";
import { useTranslation } from "../../../../../../utilities/i18n";
import { Feather } from "@expo/vector-icons";
import colors from "react-native-ui-lib/src/style/colors";

export interface TotalsProps {}

export const Totals = ({}: TotalsProps) => {
  const { t } = useTranslation("pos");
  const { totals, sale, disabled } = useCartContextProvider();

  return (
    <View style={{ paddingHorizontal: Spacings.s4 }}>
      {sale.giftVoucherCode ? (
        <View>
          <View
            paddingB-10
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  opacity: 0.5,
                }}
              >
                Voucher applied: {sale.giftVoucherCode}
              </Text>
            </View>
            <View
              style={{
                alignItems: "flex-end",
              }}
            >
              <IconButton
                Icon={
                  <Feather name="trash-2" size={20} color={colors.action} />
                }
                onPress={async () => {
                  return sale.removeGiftVoucherRedemptions().catch(console.log);
                }}
                style={{
                  borderWidth: 0,
                  padding: 0,
                  minWidth: 0,
                }}
              />
            </View>
          </View>
          <Divider marginVertical={0} marginBottom={5} />
        </View>
      ) : null}
      {totals.totalDiscount ? (
        <View
          paddingB-10
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Text style={{ fontSize: 20, opacity: 0.5 }}>
            {t("common:discounts")}
          </Text>
          <Text style={{ fontSize: 20, opacity: 0.5 }}>
            {moneyToFormattedString(totals.totalDiscount)}
          </Text>
        </View>
      ) : null}
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Text style={{ fontSize: 21, opacity: 0.5 }}>{t("common:tax")}</Text>
        <Text style={{ fontSize: 21, opacity: 0.5 }}>
          {moneyToFormattedString(totals.totalTax)}
        </Text>
      </View>
      <View
        paddingT-10
        style={{ flexDirection: "row", justifyContent: "space-between" }}
      >
        <Text
          style={{
            fontSize: 31,
            fontWeight: "bold",
            opacity: disabled ? 0.5 : 1,
          }}
          pointerEvents={false}
        >
          {t("common:total")}
        </Text>
        <Text
          style={{
            fontSize: 21,
            fontWeight: "bold",
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {moneyToFormattedString(totals.totalPrice)}
        </Text>
      </View>
    </View>
  );
};
